/* eslint-disable indent */
// Libraries
import { FormElems, Alert } from '../../components';
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';
import validate from './validator';
import { themesOptions } from './constant';
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import PictureIcon from '../../static/images/picture.png';

// eslint-disable-next-line import/order
import {
    fetchCheckoutDetailsRequest,
    addCheckoutDetailsRequest,
} from './redux/checkout.actions';

import './checkout.scss';
import { useState } from 'react';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { isEmpty } from 'lodash';

function ImageDropZone(props) {
    const {
        onFileChange,
        selectedFile,
        removeFile,
        currentImg,
        inputError,
        title,
    } = props;
    const [imgSrc, setImgSrc] = useState('');

    const onDrop = useCallback(
        acceptedFiles => {
            // Do something with the files
            onFileChange(null, acceptedFiles, true);
        },
        [onFileChange]
    );
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
    });

    useEffect(() => {
        if (selectedFile && selectedFile.length && !inputError) {
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile[0]);
            reader.onloadend = event => {
                setImgSrc([reader.result]);
            };
        } else {
            setImgSrc([]);
        }
    }, [inputError, selectedFile]);

    const dragMsg = isDragActive
        ? 'Drop the files here ...'
        : 'Drag & drop Logo here';

    return (
        <div>
            <div>
                <h2>{title}</h2>
                <div {...getRootProps()}>
                    {currentImg ? (
                        <div className="logo-preview">
                            <img src={currentImg} alt="Uploaded Logo" />
                        </div>
                    ) : (
                        <>
                            <input {...getInputProps()} />
                            <div className="logo-preview">
                                {!isEmpty(imgSrc) && !inputError ? (
                                    <img src={imgSrc} alt="Uploaded Logo" />
                                ) : (
                                    <div className="dragDrop-icon">
                                        <img src={PictureIcon} alt="Upload" />
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    {currentImg ? (
                        <p className="removeLink" onClick={removeFile}>
                            Change {title}
                        </p>
                    ) : (
                        <p>{dragMsg}</p>
                    )}
                </div>
            </div>
            <div className="alert-checkout">
                <Alert
                    customClass={inputError ? 'error-msg' : 'error-msg-hidden'}
                >
                    {inputError}
                </Alert>
            </div>
        </div>
    );
}

/**
 * CheckoutForm Component
 *
 * @param {Object} props - React component props
 */

const CheckoutForm = props => {
    const { handleSubmit, actions, checkoutData, change, auth } = props;
    const hasEntityFetched = useRef(false);

    // Header Logo
    const [headerLogoSelectedFile, setHeaderLogoSelectedFile] = useState(null);
    const [headerLogoSelectedImg, setHeaderLogoSelectedImg] = useState(
        checkoutData.data.headerLogo
    );
    const [headerLogoInputError, setHeaderLogoInputError] = useState('');

    // Loader
    const [loaderSelectedFile, setLoaderSelectedFile] = useState(null);
    const [loaderSelectedImg, setLoaderSelectedImg] = useState(
        checkoutData.data.loader
    );
    const [loaderInputError, setLoaderInputError] = useState('');

    const handleBrowse = (value, event, isDirectFile, name) => {
        if (isDirectFile && event && event.length) {
            if (name === 'headerLogo') {
                setHeaderLogoSelectedFile(event);
            } else {
                setLoaderSelectedFile(event);
            }
        } else if (event.target && event.target.files) {
            event.preventDefault();
            const files = event.target.files;
            if (name === 'headerLogo') {
                setHeaderLogoSelectedFile(files);
            } else {
                setLoaderSelectedFile(files);
            }
        }
    };

    const onRemoveFile = name => {
        if (name === 'headerLogo') {
            setHeaderLogoSelectedFile([]);
            setHeaderLogoSelectedImg(null);
        } else {
            setLoaderSelectedFile([]);
            setLoaderSelectedImg(null);
        }
    };

    useEffect(() => {
        const inputValidate = checkValidation(loaderSelectedFile, 'loader');
        setLoaderInputError(inputValidate);
    }, [loaderSelectedFile]);

    useEffect(() => {
        const inputValidate = checkValidation(
            headerLogoSelectedFile,
            'headerLogo'
        );
        setHeaderLogoInputError(inputValidate);
    }, [headerLogoSelectedFile]);

    /**
     *
     */
    useEffect(() => {
        if (auth.userDetails.associatedEntityId) {
            actions.fetchCheckoutDetailsRequest(
                auth.userDetails.associatedEntityId
            );
        }
    }, [actions, auth]);

    useEffect(() => {
        if (checkoutData.data.entityDetails && !hasEntityFetched.current) {
            if (!checkoutData.data.entityDetails.theme) {
                change('theme', 'DEFAULT');
            } else {
                change('theme', checkoutData.data.entityDetails.theme);
            }
            change(
                'primaryColor',
                checkoutData.data?.entityDetails?.checkoutUiData
                    ?.primaryCheckoutColor
            );
            setHeaderLogoSelectedImg(
                checkoutData.data?.entityDetails?.checkoutUiData?.headerLogoUrl
            );
            setLoaderSelectedImg(
                checkoutData.data?.entityDetails?.checkoutUiData?.loaderUrl
            );
            hasEntityFetched.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkoutData.data, change]);

    /**
     *
     * @param {message} values
     */

    useEffect(() => {
        if (checkoutData.addCheckout.isSuccess) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA('Checkout Customization'));
            if (auth.userDetails.associatedEntityId) {
                actions.fetchCheckoutDetailsRequest(
                    auth.userDetails.associatedEntityId
                );
            }
        } else if (checkoutData.addCheckout?.error?.errorMessage) {
            toast.error(checkoutData.addCheckout?.error?.errorMessage);
        }
    }, [checkoutData.addCheckout]);
    /**
     *
     * @param {message} values
     */

    useEffect(() => {
        if (checkoutData.updateCheckout.isSuccess) {
            toast.info(SUCCESS_MESSAGES.SAVE_DATA('Checkout Customization'));
            if (auth.userDetails.associatedEntityId) {
                actions.fetchCheckoutDetailsRequest(
                    auth.userDetails.associatedEntityId
                );
            }
        } else if (checkoutData.updateCheckout?.error?.errorMessage) {
            toast.error(checkoutData.updateCheckout?.error?.errorMessage);
        }
    }, [checkoutData.updateCheckout]);

    /**
     *
     */
    useEffect(() => {
        if (checkoutData.error.errorMessage) {
            toast.error(checkoutData.error.errorMessage);
        }
    }, [checkoutData]);

    /**
     * Method to handle form submit values for add theeme
     * @param {object} values
     * @returns {null}
     */
    function handleFormSubmit(values) {
        const payload = values;
        payload.headerLogo = headerLogoSelectedFile;
        payload.loader = loaderSelectedFile;
        if (loaderInputError || headerLogoInputError) {
            toast.error('Invalid Loader or Header Logo Format');
        } else {
            actions.addCheckoutDetailsRequest(values);
        }
    }

    return (
        <form
            className="checkout-form"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <div className="card">
                <h2 className="tab-title">Checkout Customization</h2>

                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Primary Color</p>
                        <Field
                            name="primaryColor"
                            type="text"
                            id="primary-color"
                            component={FormElems.Input}
                            placeholder="Enter Primary Color Hex Code"
                        />
                    </div>
                    <div className="form-field user-level">
                        <p className="label">Select Checkout Theme</p>
                        <Field
                            name="theme"
                            wrapperClass="buttonMode"
                            options={themesOptions}
                            valueField="value"
                            labelField="name"
                            component={FormElems.Radio}
                        />
                    </div>
                </div>
                <div className="image-container">
                    <ImageDropZone
                        title="Header"
                        onFileChange={(value, event, isDirectFile) =>
                            handleBrowse(
                                value,
                                event,
                                isDirectFile,
                                'headerLogo'
                            )
                        }
                        selectedFile={headerLogoSelectedFile}
                        currentImg={headerLogoSelectedImg}
                        inputError={headerLogoInputError}
                        removeFile={() => onRemoveFile('headerLogo')}
                    />
                    <ImageDropZone
                        title="Loader"
                        onFileChange={(value, event, isDirectFile) =>
                            handleBrowse(value, event, isDirectFile, 'loader')
                        }
                        selectedFile={loaderSelectedFile}
                        currentImg={loaderSelectedImg}
                        inputError={loaderInputError}
                        removeFile={() => onRemoveFile('loader')}
                    />
                </div>
            </div>

            <div className="form-section action">
                <div className="submit-btn">
                    <FormElems.Button buttonType="primary" text="SUBMIT" />
                </div>
            </div>
        </form>
    );
};

const checkValidation = (file, type) => {
    if (isEmpty(file)) {
        return null;
    }
    let error = null;

    if (file && file.length && file[0].size > 1000000) {
        error = 'File size should be less than 1MB';
    }

    if (type === 'headerLogo') {
        if (
            (file && file.length && file[0].type === 'image/jpeg') ||
            (file && file.length && file[0].type === 'image/png') ||
            (file && file.length && file[0].type === 'image/svg+xml')
        ) {
            error = null;
        } else {
            error = 'Invalid file format, only png, jpeg and svg type allowed';
        }
    } else if (type === 'loader') {
        if (
            (file && file.length && file[0].type === 'image/gif') ||
            (file && file.length && file[0].type === 'image/svg+xml')
        ) {
            error = null;
        } else {
            error = 'Invalid file format, only svg and gif type allowed';
        }
    }

    return error;
};

const mapStateToProps = ({ auth, checkoutData, form }) => ({
    auth,
    checkoutData,
    formData: form['checkout-form'],
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchCheckoutDetailsRequest,
            addCheckoutDetailsRequest,
            change,
        },
        dispatch
    ),
});

CheckoutForm.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    handleSubmit: PropTypes.func,
    checkoutData: PropTypes.object,
    change: PropTypes.func,
};

ImageDropZone.propTypes = {
    onFileChange: PropTypes.func,
    selectedFile: PropTypes.array,
    removeFile: PropTypes.any,
    currentImg: PropTypes.any,
    inputError: PropTypes.any,
    title: PropTypes.string,
};

export default compose(
    reduxForm({
        form: 'checkout-form',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(CheckoutForm);
